export default {
  de: {
    wrongPassword: 'Falsches Passwort',
    exist: 'Existiert bereits',
    2: 'Existiert bereits',
    bic: "Fehlerhafter BIC"
  }
}
